import React, { useRef } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/hemmexus.png";
import avatarVideo from "../../assets/avatares/video-5-green.webm";
import avatarVideoMp4 from "../../assets/avatares/video-5-green.mp4";
import manuelVideo from "../../assets/bg/silent-video-manuel.webm";
import manuelVideoMp4 from "../../assets/bg/silent-video-manuel.mp4";
import flechaAvanzar from "../../assets/right-arrow.svg";
import { modalPresentacionManuel } from "../../utils/logger";
import ScenarioBar from "../../components/ScenarioBar";
import NextButton from "../../components/NextButton";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";

function Scenario5Intro({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const { videoRef, canPlayWithSound } = useVideoWithSound({ 
		autoPlay: true, 
		volume: 0.8
	});

	const transcription = "Doctor, la verdad me siento cansado desde hace meses... Voy mucho al baño en las noches, y últimamente he notado un dolor en la espalda baja y en mi cadera derecha. Me molesta caminar o estar sentado por mucho tiempo, por lo que paso mucho tiempo acostado para evitar el dolor. Vine porque quiero saber qué me está pasando... Tengo miedo de que sea algo serio."


	const handleContinue = () => {
		navigate(ROUTES.SCENARIO5);
	};

	const activeScenario = getScenarioNumByPath(location.pathname);

	return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-between h-100 px-4 pb-4">
						<img
							src={oncommit}
							alt="decorativo"
							style={{
								maxWidth: "50%",
								marginTop: "24px",
							}}
						/>
						<video
							ref={videoRef}
							className="mb-4 pb-5"
							autoPlay
							playsInline
							preload="auto"
							muted
						>
							<source src={avatarVideoMp4}  type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
					</div>

					{/* Columna derecha: espacio visual */}
					<div className="col-md-8 d-flex flex-column justify-content-center align-items-end bg-blur-green h-100 px-5">
						<div className="recuadro-white-no-border txtTexto1 mb-3 w-100">
							<h3 className="txtTitulos txt-red mb-4">
								A continuación
							</h3>
							<p>
								Se presenta la evolución a largo plazo de Juan bajo el tratamiento con teclistamab, así como las estrategias de soporte y profilaxis que han optimizado la seguridad de Juan durante el tratamiento.
							</p>
        					<div className="notaCasoClinicoAutor">caso clínico del autor</div>
						</div>
						<NextButton
							navigateTo={ROUTES.SCENARIO5}
							activeScenario="1"
							color="green"
							textColor="white"
						/>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario5Intro);
